import { FeaturesEnum } from '~/features/types';

export default [
  {
    path: '/tickets',
    meta: {
      auth: true,
      feature: FeaturesEnum.TICKET_WALLET,
    },
    component: () => import('~/common/layouts/default.vue'),
    children: [
      {
        path: '',
        name: 'tickets',
        component: () => import('~/ticketWallet/pages/Index.vue'),
      },
      {
        path: '/tickets/user/:id',
        name: 'ViewTickets',
        component: () => import('~/ticketWallet/pages/View.vue'),
        props(route) {
          let props = { ...route.params };
          return props;
        },
      },
    ],
  },
];
